export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, user-scalable=no"},{"charset":"utf-8"},{"name":"description","content":"Ta' med på en sportsrejse i Europa og få en oplevelse for livet. Vi har desuden valgt at udvide til flere sportsgrene, så man eksempelvis også kan opleve Formel 1, NFL og Rugby."},{"name":"author","content":"Fodboldpakker"},{"property":"og:title","content":"Fodboldpakker - Sportsrejser til de største ligaer i Europa"},{"property":"og:description","content":"Ta' med på en sportsrejse i Europa og få en oplevelse for livet. Vi har desuden valgt at udvide til flere sportsgrene, så man eksempelvis også kan opleve Formel 1, NFL og Rugby."},{"property":"og:url","content":"https://fodboldpakker.dk"},{"property":"og:type","content":"website"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Fodboldpakker - Sportsrejser til de største ligaer i Europa"},{"name":"twitter:description","content":"Ta' med på en sportsrejse i Europa og få en oplevelse for livet."}],"link":[{"rel":"canonical","href":"https://fodboldpakker.dk"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, user-scalable=no","title":"Fodboldpakker - Sportsrejser til de største ligaer i Europa"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"